var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"close-icon",attrs:{"small":"","left":"","color":"grey","outline":""},on:{"click":function($event){return _vm.$emit('remove')}}},[_vm._v("mdi-close-circle")])}
var staticRenderFns = []

export { render, staticRenderFns }